// Approximate lat/lng regions for US + Canada (continental, Alaska, Hawaii).

export function isLatLngInUsCa(lat, lng) {
  const la = Number(lat)
  const ln = Number(lng)
  if (!Number.isFinite(la) || !Number.isFinite(ln)) return false
  if (la === 0 && ln === 0) return false

  // Hawaii
  if (la >= 18 && la <= 23 && ln >= -161 && ln <= -154) return true
  // Alaska (incl. Aleutians)
  if (la >= 51 && la <= 72 && ln >= -180 && ln <= -129) return true
  // Continental US + Canada
  if (la >= 24 && la <= 72 && ln >= -141 && ln <= -52) return true

  return false
}
